<template>
    <div class="animated fadeIn">
        <CCard>
            <CCardHeader><font-awesome-icon icon="list-ul"/> Groups</CCardHeader>
            <CCardBody>
                <CDataTable
                    :items="group_lists"
                    :fields="group_lists_fields"
                    :table-filter="{ placeholder: 'Your text here.', label: 'Search:'}"
                    :items-per-page="10"
                    border
                    items-per-page-select
                    sorter
                    pagination
                    :loading="this.table_loading"
                >
                <template slot="no-items-view" v-if="this.table_loading">
                    <center>
                        <CSpinner
                            style="width:4rem;height:4rem;"
                            color="info"
                        />
                    </center>
                </template>
                <template #icon="{item}">
                    <td>
                        <center>
                            <CIcon :name="item.icon" size="xl" />
                        </center>
                    </td>
                </template>
                <template #description="{item}">
                    <td>
                        {{item.description ? item.description : ''}}
                    </td>
                </template>
                <template #Action="{item}">
                    <td>
                        <router-link :to="{path: `/${$store.getters['getOrganizationName']}/administrator/group/${item.id}`}">
                            <CButton 
                                color="info" 
                                shape="pill" 
                                size="sm"
                            >
                                <font-awesome-icon icon="cog"/> Manage
                            </CButton>
                        </router-link>
                    </td>
                </template>
                <template #status="{item}">
                    <td>
                        <CBadge :color="getColorStatus(item.status)">
                            {{item.status}}
                        </CBadge>
                    </td>
                </template>
                </CDataTable>
            </CCardBody>
        </CCard>   
    </div>
</template>
<script>
export default {
    name: 'GroupLists',
    data() {
        return {
            table_loading: true,
            group_lists: [],
        }
    },
    created () {
        this.getGroups();
        this.$emit('activeTab', 0);
    },
    computed: {
            group_lists_fields: function () {
            let custom_fields= [
                { key: 'icon', sorter: false},
                { key: 'name', label: 'Name'},
                { key: 'path'},
                { key: 'description' },
                { key: 'status' },
            ]
            if(this.$store.getters.can('view-group')) {
                custom_fields.push({ key: 'Action', sorter: false})
            }
            return custom_fields;
        }
    },
    methods: {
        getGroups: function () {
            this.$Progress.start()
            axios.get('/groups/list', {validateStatus: () => true})
            .then(response => {
                if(response.status == 200) {
                    for (let i = 0; i < response.data.data.length; i++) {
                        let row = {
                                id:  response.data.data[i].id, 
                                icon:  response.data.data[i].icon, 
                                name:  response.data.data[i].name, 
                                path:  response.data.data[i].path, 
                                description: response.data.data[i].description, 
                                status: response.data.data[i].deleted_at ? 'Archived' : 'Active', 
                        }
                        this.group_lists.push(row)
                    }
                    this.table_loading = false;
                    this.$Progress.finish()
                }
            })
        },
    }
}
</script>